<nmviajes-loading></nmviajes-loading>
<app-notification></app-notification>

<app-toolbar></app-toolbar>
<router-outlet></router-outlet>

@if (isBookingRoute) {
  <app-footer-checkout></app-footer-checkout>
} @else if (!isTravelOutletRoute) {
  @for (section of dataPagePresenterService.data.sections; track $index) {
    <app-footer
      *ngIf="section.section === 'Footer'"
      [title1]="section.title1"
      [list1]="options"
      [title2]="section.title2"
      [list2]="section.list2"
      [title3]="section.title3"
      [address]="section.address"
    ></app-footer>
  }
  <app-pre-footer></app-pre-footer>
}

@if (showWhatsAppToggler) {
  <app-chat-launcher></app-chat-launcher>
}

@if (showCookieBanner) {
  <app-cookie-banner (hide)="showCookieBanner = false"></app-cookie-banner>
}
